import * as moment from 'moment';
import TZDate from './TZDate';
import { TZUtils } from './tzutils';

// Convert a TZDate to a moment object while preserving offset. Suitable for formatting/display.
export function tzmoment(date : TZDate | string) : moment.Moment {
    const json = date instanceof TZDate ? date.toJSON() : date,
        // TH 05/02/2017 -- UPDATE: Moment has fixed my bugs w/ parseZone! See:
        // https://github.com/moment/moment/issues/3520
        // https://github.com/moment/moment/pull/3523
        // https://github.com/moment/moment/pull/3643
        m = moment.parseZone(json);
    return m;
}

// Convert a moment object to a TZDate. Assumes moment object has had offset set correctly.
export function momentToTZDate(m : moment.Moment) {
    return new TZDate(+m, -m.utcOffset());
}

// Use moment to modify a TZDate and get back a TZDate with the proper offset for the timezone and new date
export function tzmomentMod(tzutils: TZUtils, date : TZDate, operator : (m : moment.Moment) => moment.Moment) : TZDate {
    const json = date.toJSON(),
        m = moment.parseZone(json).tz(tzutils.timezone); // tell moment about the timezone, so that operations like .add(1, 'day') can account for DST
    return tzutils.newDate(+operator(m));
}


// WEBPACK FOOTER //
// ./lib/tzmoment.ts